import $ from 'jquery';
import { TAB_MAP, activateTab } from './mi-tabs-navigation';

const EMPTY_MARKERS = [
	'No data found.',
	'No data found',
	'No testimonials found',
	'Please check your ACF field settings',
];

const isPanelEmpty = ($panel) => {
	if (!$panel || !$panel.length) return true;

	const $clone = $panel.clone();
	$clone.find('.elementor-widget-spacer, .elementor-widget-divider, svg').remove();

	let text = $clone.text();

	EMPTY_MARKERS.forEach((marker) => {
		const escaped = marker.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
		text = text.replace(new RegExp(escaped, 'gi'), '');
	});

	const remaining = text.replace(/\s+/g, ' ').trim();
	const hasMediaOrInteractive =
		$clone.find('img, iframe, video, input, select, textarea').length > 0;

	if (remaining === '' && !hasMediaOrInteractive) return true;

	return false;
};

const miTabsHideEmpty = () => {
	$('.mi-tabs .e-n-tabs').each(function () {
		const $tabs = $(this);
		const $buttons = $tabs.find('> .e-n-tabs-heading > .e-n-tab-title');
		const $panels = $tabs.find('> .e-n-tabs-content > [role="tabpanel"]');

		const visibilityData =
			window.parameters && window.parameters.tab_visibility
				? window.parameters.tab_visibility
				: null;

		$buttons.each(function () {
			const $btn = $(this);
			const btnId = ($btn.attr('id') || '').toLowerCase();
			const btnText = $btn.text().trim().toLowerCase();
			const tabIndex = $btn.attr('data-tab-index');
			const $panel = $panels.filter('[data-tab-index="' + tabIndex + '"]');

			let matchedKey = null;
			for (const key in TAB_MAP) {
				const config = TAB_MAP[key];
				if (
					config.ids.includes(btnId) ||
					config.texts.some((t) => btnText.includes(t))
				) {
					matchedKey = key;
					break;
				}
			}

			let shouldHide = false;

			if (
				visibilityData &&
				matchedKey &&
				matchedKey in visibilityData &&
				!visibilityData[matchedKey]
			) {
				shouldHide = true;
			} else if ($panel.length && isPanelEmpty($panel)) {
				shouldHide = true;
			}

			if (shouldHide) {
				$btn.addClass('mi-tab-hidden').hide();
				if ($panel.length) {
					$panel.addClass('mi-tab-hidden').hide();
				}
			} else {
				$btn.removeClass('mi-tab-hidden').show();
				if ($panel.length) {
					$panel.removeClass('mi-tab-hidden');
				}
			}
		});

		// ALWAYS ensure the leftmost (first visible) tab is active
		const $visibleButtons = $buttons.not('.mi-tab-hidden').filter(':visible');
		const $activeBtn = $visibleButtons.filter('[aria-selected="true"]');

		if (!$activeBtn.length && $visibleButtons.length) {
			activateTab($visibleButtons.first(), $tabs, $buttons, $panels);
		} else if ($visibleButtons.length) {
			// Ensure the currently active button's panel is displayed
			const activeIdx = $activeBtn.first().attr('data-tab-index');
			const $activePanel = $panels.filter('[data-tab-index="' + activeIdx + '"]');
			if ($activePanel.length && !$activePanel.is(':visible')) {
				$activePanel.addClass('e-active').show();
			}
		}
	});
};

$(function () {
	try {
		setTimeout(miTabsHideEmpty, 150);
		setTimeout(miTabsHideEmpty, 500); // Secondary check in case Elementor finishes late
	} catch (error) {
		console.warn('mi-tabs-hide-empty:', error);
	}
});
